import NextStepsBody from './NextStepsBody';
import type { NextStepsData, NextStepItem } from './NextStepsBody';

export type { NextStepsData, NextStepItem };

const NextStepsView = ({ data }: { data: NextStepsData }) => (
  <NextStepsBody data={data} />
);

export default NextStepsView;
